import { render, staticRenderFns } from "./UserNotificationsTable.vue?vue&type=template&id=0cdc6cc8&scoped=true&"
import script from "./UserNotificationsTable.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationsTable.vue?vue&type=style&index=0&id=0cdc6cc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc6cc8",
  null
  
)

export default component.exports